/* eslint-disable react/jsx-props-no-spreading */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  type DialogProps,
  DialogTitle,
} from '@efexteam/components';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FirstStepAccountStatus from './accountstatusstep/step1';
import SecondStepAccountStatus from './accountstatusstep/step2';

type AccountStatusModalProps = DialogProps & {
  onClose: () => void;
};

enum AccountStatusPage {
  dateSelector = 1,
  downloadInvoice = 2,
}

const AccountStatusModal = ({
  open,
  onClose,
  ...props
}: AccountStatusModalProps) => {
  const { t } = useTranslation();
  const [valueDateIssue, setValueDateIssue] = useState('');
  const [keyDateIssue, setKeyDateIssue] = useState('');
  const [page, setPage] = useState(1);

  const goNextPage = async () => {
    setPage((statePage) => statePage + 1);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="pb-5"
      fullWidth
      maxWidth="sm"
      {...props}
    >
      <DialogTitle showCloseButton onClick={onClose} />
      <DialogContent>
        {page === AccountStatusPage.dateSelector && (
          <FirstStepAccountStatus
            setValueDateIssue={setValueDateIssue}
            setKeyDateIssue={setKeyDateIssue}
          />
        )}
        {page === AccountStatusPage.downloadInvoice && (
          <SecondStepAccountStatus
            keyDateIssue={keyDateIssue}
            valueDateIssue={valueDateIssue}
          />
        )}
      </DialogContent>
      <DialogActions>
        {page === AccountStatusPage.dateSelector && (
          <Button
            appearance="primary"
            type="button"
            onClick={goNextPage}
            size="large"
            className={clsx('!mt-4', !valueDateIssue.length && 'disabled')}
            disabled={!valueDateIssue.length}
          >
            {t('generate')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AccountStatusModal;
